import React, { useState, useEffect, useRef } from "react";
import {useNavigate} from 'react-router-dom'
import {host} from './env'
interface TickerSearchResult {
  ticker: string;
  companyName: string;
}

const TickerSearch: React.FC = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<TickerSearchResult[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (query.trim() === "") {
      setResults([]);
      return;
    }

    // Debounce search
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      fetch(`${host}/tickerSearch?tickerText=${encodeURIComponent(query)}`)
        .then((res) => res.json())
        .then((data: TickerSearchResult[]) => {
          setResults(data);
          setShowDropdown(true);
        })
        .catch((err) => {
          console.error("Search error:", err);
          setResults([]);
        });
    }, 300); // 300ms debounce
  }, [query]);

  const handleSelect = (ticker: string) => {
    navigate(`/ticker/${ticker}`);
    setQuery(""); // optional: clear input
    setResults([]);
    setShowDropdown(false);
  };

  return (
    <div style={{ position: "relative", width: "300px" }}>
      <input
        type="text"
        value={query}
        placeholder="Search ticker..."
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => query && results.length > 0 && setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
        style={{ width: "100%", padding: "8px", fontSize: "1rem" }}
      />
      {showDropdown && results.length > 0 && (
        <ul
          style={{
            listStyle: "none",
            margin: 0,
            padding: 0,
            position: "absolute",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            width: "100%",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {results.map((r) => (
            <li
              key={r.ticker}
              onMouseDown={() => handleSelect(r.ticker)}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
            >
              <strong>{r.ticker}</strong> – {r.companyName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TickerSearch;
